import { render, staticRenderFns } from "./sendForm.vue?vue&type=template&id=daf68c90&scoped=true&"
import script from "./sendForm.vue?vue&type=script&lang=js&"
export * from "./sendForm.vue?vue&type=script&lang=js&"
import style0 from "./sendForm.vue?vue&type=style&index=0&id=daf68c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf68c90",
  null
  
)

export default component.exports